import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneInput.styl';

/**
 * @event onEnter {value:string} при нажатии на enter
 * @event onInput {value:string}
 * @event onFocus {}
 * @event onBlur {}
 */
Vue.component('BXmakerAuthuserphoneInput',
    {
        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: () => {
                    return Math.random().toString(16).substring(2, 8) + '_' + (new Date).getTime();
                }
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            validationMessage: {
                type: [String, Boolean],
                default: false
            },
            maxLength: {
                type: [Number, Boolean],
                default: false
            },
            mask: {
                type: [ Object],
                default: () => {
                    return {};
                }
            },
            as: {
                type: String,
                default: ''
            }
        },
        data: function () {
            return {
                inFocus: false,
                isHover: false,
                currentType: this.type,
                currentPlaceholder: this.placeholder,
            };
        },
        computed: {
            classes() {
                let ar = [];
                if (this.inFocus || this.value.length > 0) {
                    ar.push('bxmaker-authuserphone-input--focus');
                }
                if (this.isHover) {
                    ar.push('bxmaker-authuserphone-input--hover');
                }

                if (this.validationMessage) {
                    ar.push('bxmaker-authuserphone-input--invalid');
                }

                return ar;
            },
            visiblePlaceholder() {
                if (this.inFocus || this.isHover) {
                    return this.currentPlaceholder;
                }
                return '';
            },
            isEnabledIMask() {
                return (this.mask && this.mask.type === 'imask')
            }

        },
        mounted() {
            if (this.isEnabledIMask) {

                this.setPlaceholder(this.mask.placeholder);

                if (!!window.IMask) {
                    this.initMask();
                } else if (!window.BXmakerAuthUserPhoneImaskLoading) {
                    window.BXmakerAuthUserPhoneImaskLoading = true;

                    let lib = document.createElement('script');
                    lib.type = "text/javascript";
                    lib.src = 'https://unpkg.com/imask';
                    lib.dataset.module = "bxmaker.authuserphone";
                    lib.onload = () => {
                        setTimeout(() => {
                            this.initMask()
                        }, 100);
                    }
                    document.body.appendChild(lib);

                } else {

                   this._waitLibInterval =  setInterval(() => {
                        if(window.IMask)
                        {
                            clearInterval(this._waitLibInterval);
                            this.initMask();
                        }
                    }, 200);
                }
            }

        },
        beforeDestroy() {
            if(this._waitLibInterval)
            {
               clearInterval(this._waitLibInterval);
            }
            this.destroyMask();
        },
        methods: {
            onFocus() {
                this.inFocus = true;
                this.$emit('onFocus');
            },
            onBlur() {
                this.inFocus = false;
                this.$emit('onBlur');
            },
            onInput(e) {
                if(this._imaskInited)
                {
                    return;
                }

                this.setValue(e.target.value);
            },
            setValue(value) {
                this.$emit('onInput', value)
            },
            onKeydown(e) {
                switch (e.keyCode) {
                    case 13://enter
                    {
                        this.$emit('onEnter', e.target.value)
                        return;
                    }
                }
            },
            onMouseenter() {
                this.isHover = true;
            },
            onMouseleave() {
                this.isHover = false;
            },
            // активация фокуса на поле
            focus() {
                this.$refs.input.focus();
            },
            setPlaceholder(value) {
                this.currentPlaceholder = value;
            },
            setType(value) {
                this.currentType = value;
            },
            destroyMask() {
                if (this.isEnabledIMask && this._imask && this._imask.destroy) {
                    this._imask.destroy();
                }
            },
            initMask() {
                if (this.isEnabledIMask) {
                    this._imaskInited =  true;
                    this._imask = window.IMask(this.$refs.input, {
                        mask: this.mask.format,
                    });
                    this._imask.on('accept',  () => {
                        setTimeout(() => {
                            this.setValue(this._imask.value);
                        }, 10);
                    });

                }
            }
        },
        //language=Vue
        template: `
          <div class="bxmaker-authuserphone-input " :class="classes">
          <div class="bxmaker-authuserphone-input__field">
            <input
                :type="currentType"
                :placeholder="visiblePlaceholder"
                :name="name"
                @focus="onFocus"
                @blur="onBlur"
                @input="onInput"
                @mouseenter="onMouseenter"
                @mouseleave="onMouseleave"
                @keydown="onKeydown"
                :value="value"
                autocomplete="off"
                :maxlength="maxLength"
                ref="input"
            >
            <span class="bxmaker-authuserphone-input__title">{{title}}</span>
          </div>
          <div class="bxmaker-authuserphone-input__validation" v-if="validationMessage">{{validationMessage}}</div>
          </div>
        `,
    });